import NotasFiscaisView from "../../components/estoque/NotasFiscaisView";

export default function NotasFiscaisEstoque() {
  return <NotasFiscaisView />;
}
